import Forms from '../components/Forms';
import NavBarComponent from '../components/NavBarComponent';

function Form() {
  return (
    <>
      <NavBarComponent />
      <Forms />
    </>
  );
}

export default Form;